<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><g
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    clip-path="url(#a)"
  ><path d="M9.821 22.198a10.43 10.43 0 1 1 12.516-11.589" /><path d="m5.51 20.158.928-4.681h1a1.373 1.373 0 0 0 1.095-.538 1.336 1.336 0 0 0 .25-1.187l-.695-2.781a1.381 1.381 0 0 0-1.344-1.057H1.802M20.344 5.742h-3.783A1.381 1.381 0 0 0 15.217 6.8l-.436 1.77M12.916 20.813a5.495 5.495 0 0 0 3.924 1.612 5.622 5.622 0 0 0 5.581-5.581 5.53 5.53 0 0 0-.415-2.125 5.494 5.494 0 0 0-5.12-3.41 5.621 5.621 0 0 0-5.581 5.581 5.53 5.53 0 0 0 .414 2.125 5.493 5.493 0 0 0 1.197 1.798ZM12.937 20.798l7.861-7.862" /></g><defs><clipPath id="a"><path
    fill="none"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
